'use strict';

import {EwSiteApp} from "./ewsiteapp.js";

EwSiteApp.controller('LayoutCtrl', ["$scope", "$mdSidenav", "$mdDialog", "$mdMedia", "jsDataService", "pageProgress", function ($scope, $mdSidenav, $mdDialog, $mdMedia, jsDataService, pageProgress) {
    $scope.rightNavTabs = {
        selectedIndex: 0
    };
    $scope.openMenu = function () {
        $mdSidenav('left').open();
    };
    $scope.closeMenu = function () {
        $mdSidenav('left').close();
    };
    $scope.openRight = function () {
        $scope.rightNavTabs.selectedIndex = 0;
        if (arguments[0] && !isNaN(arguments[0]) && arguments[0] > 0) {
            $scope.rightNavTabs.selectedIndex = parseInt(arguments[0]);
        }
        $mdSidenav('right').open();
    };
    $scope.toggleSidenav = buildToggler('left');
    $scope.toggleRightNav = buildToggler('right');

    function buildToggler(componentId) {
        return function () {
            $mdSidenav(componentId).toggle();
        };
    }

    $scope.timeCfg = function () {
        return jsDataService.get('cfgTime', {});
    };

    $scope.isMedia = function (sz) {
        return $mdMedia(sz);
    };

    window.onbeforeunload = function (event) {
        pageProgress.start();
    };

    $scope.$on('$locationChangeStart', function (event, newLocation, oldLocation) {
        if (newLocation !== oldLocation) {
            pageProgress.start();
        }
    });

    $scope.$on('$destroy', function (e) {
        delete window.onbeforeunload;
    });
}]);

class expandCtrl {
    constructor($scope) {
        this.$scope = $scope;
        this.opened = false;
        this.disabled = false;
        this.touched = {};
        this.tipOpen = {};
        this.tipVisible = {};
    }

    anySelected(fid) {
        var g = this.$scope.formMdlMulti && this.$scope.formMdlMulti[fid];
        if (!g) return false;
        for (var k in g) {
            if (Object.prototype.hasOwnProperty.call(g, k) && g[k]) return true;
        }
        return false;
    }

    touch(fid) {
        this.touched[fid] = true;
    }

    isOpen() {
        return this.opened;
    }

    toggle() {
        if (!this.isDisabled()) this.opened = !this.opened;
    }

    open() {
        if (!this.isDisabled()) this.opened = true;
    }

    close() {
        if (!this.isDisabled()) this.opened = false;
    }

    openFrame(onOpen, onClose) {
        return (this.opened) ? onOpen : onClose;
    }

    isDisabled() {
        return this.disabled;
    }

    disable() {
        this.disabled = true;
    }

    enable() {
        this.disabled = false;
    }

    ensureTipMap(fid) {
        if (!this.tipVisible[fid]) this.tipVisible[fid] = {};
    }

    onSelOpen(fid) {
        this.tipOpen[fid] = true;
    }

    onSelClose(fid) {
        this.tipOpen[fid] = false;
        this.tipVisible[fid] = {};
    }

    showTip(fid, cid) {
        this.ensureTipMap(fid);
        if (this.tipOpen[fid]) this.tipVisible[fid][cid] = true;
    }

    hideTip(fid, cid) {
        this.ensureTipMap(fid);
        this.tipVisible[fid][cid] = false;
    }

    ensureDate(cur, raw) {
        if (cur) return cur;
        if (raw) return new Date(raw);
        return new Date();
    }
}

expandCtrl.$inject = ['$scope'];
EwSiteApp.controller('expandCtrl', expandCtrl);


EwSiteApp.directive('fileModel', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            var maxBytes = null;
            if (attrs.maxBytes) maxBytes = parseInt(attrs.maxBytes, 10);
            else if (attrs.maxMb) maxBytes = Math.round(parseFloat(attrs.maxMb) * 1024 * 1024);

            ngModel.$validators.maxSize = function (modelValue, viewValue) {
                var f = modelValue || viewValue;
                if (!f || maxBytes == null) return true;
                return f.size <= maxBytes;
            };

            element.on('change', function () {
                var file = element[0].files && element[0].files.length ? element[0].files[0] : null;
                scope.$apply(function () {
                    ngModel.$setViewValue(file);
                    ngModel.$setTouched();
                    ngModel.$setDirty();
                });
            });
        }
    };
});


